import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ParentEnrollmentForm } from "@/components/ParentEnrollmentForm";
import { useEnrollmentSettings } from "@/hooks/useAppSettings";
import { Loader2 } from "lucide-react";

const ParentEnrollment = () => {
  const { isEnrollmentEnabled, enrollmentStartDate, enrollmentEndDate, enrollmentMessage, loading } = useEnrollmentSettings();

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-background to-muted p-4 flex items-center justify-center">
        <div className="flex items-center space-x-2">
          <Loader2 className="h-6 w-6 animate-spin" />
          <span>Cargando portal de inscripción...</span>
        </div>
      </div>
    );
  }


  // Verificar si el portal está habilitado
  if (isEnrollmentEnabled === false) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-background to-muted p-4">
        <div className="max-w-2xl mx-auto space-y-6 pt-20">
          <Card className="shadow-lg border-orange-200 bg-orange-50/50">
            <CardHeader className="text-center">
              <CardTitle className="text-2xl text-orange-800">Portal de Inscripción Cerrado</CardTitle>
              <CardDescription className="text-orange-700">
                El proceso de inscripción no está disponible en este momento.
              </CardDescription>
            </CardHeader>
            <CardContent className="text-center">
              <p className="text-orange-700">
                Por favor, contacta con el centro educativo para más información sobre las inscripciones.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    );
  }

  // Verificar fechas de inscripción
  const now = new Date();
  const startDate = enrollmentStartDate ? new Date(enrollmentStartDate) : null;
  const endDate = enrollmentEndDate ? new Date(enrollmentEndDate) : null;

  const isBeforeStart = startDate && now < startDate;
  const isAfterEnd = endDate && now > endDate;

  if (isBeforeStart || isAfterEnd) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-background to-muted p-4">
        <div className="max-w-2xl mx-auto space-y-6 pt-20">
          <Card className="shadow-lg border-orange-200 bg-orange-50/50">
            <CardHeader className="text-center">
              <CardTitle className="text-2xl text-orange-800">
                {isBeforeStart ? 'Inscripciones Próximamente' : 'Período de Inscripción Finalizado'}
              </CardTitle>
              <CardDescription className="text-orange-700">
                {isBeforeStart 
                  ? `Las inscripciones estarán disponibles a partir del ${startDate?.toLocaleDateString('es-ES', { 
                      day: '2-digit', 
                      month: '2-digit', 
                      year: 'numeric' 
                    })}`
                  : `El período de inscripción finalizó el ${endDate?.toLocaleDateString('es-ES', { 
                      day: '2-digit', 
                      month: '2-digit', 
                      year: 'numeric' 
                    })}`
                }
              </CardDescription>
            </CardHeader>
            <CardContent className="text-center">
              <p className="text-orange-700">
                Por favor, contacta con el centro educativo para más información.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-background to-muted p-4">
      <div className="max-w-2xl mx-auto space-y-6">
        <div className="text-center space-y-2 py-8">
          <h1 className="text-4xl font-bold text-foreground">Actividades Extraescolares Corazonistas Haro</h1>
          <p className="text-xl text-muted-foreground">
            {enrollmentMessage || 'Inscribe a tu hijo/a en nuestras actividades extraescolares'}
          </p>
        </div>

        <Card className="shadow-lg">
          <CardHeader className="text-center">
            <CardTitle className="text-2xl">Formulario de Inscripción Extraescolares</CardTitle>
            <CardDescription>
              Completa todos los campos para inscribir a tu hijo/a en la actividad deseada
            </CardDescription>
          </CardHeader>
          <CardContent>
            <ParentEnrollmentForm />
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ParentEnrollment;